import SignInView from './sign-in-view';

export default SignInView;
